import { Component } from '@angular/core';
import { BaseManagePasswordComponent } from '@app/components/_shared/account/base-manage-password/base-manage-password.component';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent extends BaseManagePasswordComponent {
  static route: string = 'change-password';

  // BaseManagePasswordComponent template variables to be passed
  templateSettings = {
    headerLegend: false,
    showMessagesTop: true,
    changePasswordMessage: true
  };
}



// WEBPACK FOOTER //
// ./src/app/components/account/change-password/change-password.component.ts